import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './ScrollToTopComponent';
import { HelmetProvider } from 'react-helmet-async';
import {  ScrollRestoration, BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './Layout'; //main layout with navbar y footer
import Home from './pages/Home';
import Roadmap from './pages/Roadmap';
import Products from './pages/Products';
import Media from './pages/Media';
import Releases from './pages/Releases';
import Clients from './pages/Gallery';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop /> {/* Place this component inside Router but outside Routes */}
        <Routes>
          {/* The Layout route acts as a wrapper for all nested routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} /> {/* Renders Home at "/" */}
            <Route path="/products" element={<Products />} />
            <Route path="/products/#integrity" element={<Products />} />
            <Route path="/products/#cloud" element={<Products />} />
            <Route path="/roadmap" element={<Roadmap />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/media" element={<Media />} />
            <Route path="/releases" element={<Releases />} />
          </Route>
        {/* Add other routes outside the layout if you need pages without the navbar (e.g., a login page) */}
        {/* <Route path="/login" element={<Login />} /> */}
      </Routes>
      <App />
    </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
